<template>
  <pl-dialog
    :title="'New Poll'"
    :size="'md'"
    :disableOutsideClick="true"
    @close="$emit('closePollDialog')"
  >
    <body class="px-7 py-4 flex-grow overflow-y-auto">
      <p class="font-semibold pb-2">Question</p>
      <input
        ref="input-title"
        v-model="question"
        class="bg-input text-sm flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300"
        :placeholder="'Enter your question here'"
        type="text"
        maxlength="120"
      />
      <p class="font-semibold pt-4 pb-2">Options</p>
      <div
        class="flex justify-between items-center pb-2"
        v-for="(answer, index) in answers"
        :key="`answer-${answer}-${index}`"
      >
        <input
          class="bg-input text-sm flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300"
          v-model="answer.text"
          :placeholder="`Add option ${index + 1}`"
          maxlength="40"
        />
        <i
          v-if="index > 1"
          class="fas fa-trash-alt w-5 mx-2 text-center text-red-200 hover:text-red-700 cursor-pointer"
          @click="deleteAnswer(index)"
        ></i>
      </div>
      <div v-if="answers.length < 6" class="flex justify-between items-center">
        <input
          v-model="new_answer.text"
          class="bg-input text-sm flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300"
          placeholder="Add another option"
          maxlength="40"
          v-on:keyup.enter="addAnswer()"
          
        />
        <i
          @click="addAnswer"
          class="fas fa-plus-circle text-xl w-5 mx-2 text-center text-gray-400 hover:text-gray-700 cursor-pointer"
        ></i>
      </div>
    </body>
    <footer class="flex justify-between items-center pt-5 pb-5 px-7">
      <div>
        <button
          @click="$emit('deletePoll')"
          class="w-24 py-2 bg-red-400 rounded text-white font-semibold"
        >
          Delete
        </button>
      </div>
      <div>
        <button
          class="w-24 py-2 bg-gray-100 rounded text-gray-400 font-semibold"
          @click="saveAndClose"
        >
          Save
        </button>
        <button
          v-if="selectedPoll.live_discussion_id"
          :disabled="!question || !options_with_text"
          @click="startPoll"
          class="w-24 py-2 ml-2 bg-primary rounded text-white font-semibold disabled:opacity-50"
        >
          Start
        </button>
      </div>
    </footer>
  </pl-dialog>
</template>

<script>
  import every from 'lodash/every';
  import { mapGetters } from 'vuex';
  import textbox from 'components/textbox';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        question: '',
        answers: [],
        new_answer: {
          text: '',
        },
      };
    },
    components: {
      textbox,
    },
    props: {
      selectedPoll: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion', 'getProfile']),
      options_with_text() {
        return every(this.answers, (a) => a.text.length > 0);
      },
    },
    methods: {
      saveAndClose() {
        const answers = this.answers.map((a) => a.text.trim());
        const poll_author_id = this.getProfile.id;
        const payload = { answers, question: this.question, poll_author_id };
        if (this.selectedPoll.premade_id) {
          this.$store
            .dispatch('editPremadePoll', {
              poll_id: this.selectedPoll.id,
              payload,
            })
            .then(() => {
              this.$emit('closePollDialog');
              this.$emit('pollChanges', payload);
              const toast = {
                type: 'Success',
                message: 'Poll edited!',
                time: 5000,
              };
              EventBus.$emit('createToast', toast);
            });
        } else {
          this.$store
            .dispatch('editPoll', {
              poll_id: this.selectedPoll.id,
              payload,
            })
            .then(() => {
              this.$emit('closePollDialog');
              const toast = {
                type: 'Success',
                message: 'Poll edited!',
                time: 5000,
              };
              EventBus.$emit('createToast', toast);
            });
        }
      },
      startPoll() {
        if (this.question && !this.question_is_too_long) {
          const answers = this.answers.map((a) => a.text.trim());
          //const poll_author_id = this.getProfile.id;
          this.$store.dispatch('editPoll', {
            poll_id: this.selectedPoll.id,
            payload: {
              status: 'live',
              answers,
              question: this.question,
            },
          });
          /*const toast = {
            type: 'Success',
            message: 'New poll created!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);*/
        }
      },
      addAnswer() {
        if (this.at_least_one_answer_is_too_long) {
          return;
        }
        const answers = this.answers.map((a) => a.text.trim());
        if (answers.includes(this.new_answer.text.trim())) {
          this.new_answer.text = '';
          return window.alert('Please enter a unique option');
        }
        if (this.new_answer.text) {
          const answer = { ...this.new_answer };
          answer.text = answer.text.trim();
          this.answers.push(answer);
          this.new_answer = {
            text: '',
          };
        }
      },
      deleteAnswer(index) {
        this.answers.splice(index, 1);
      },
      closePollDialog() {
        this.$emit('closePollDialog');
      },
    },
    mounted() {
      // Convert answers to format that is readable by component
      this.answers = this.selectedPoll.answers.map((a) => ({
        text: a,
      }));
      this.question = this.selectedPoll.question;
    },
  };
</script>



// WEBPACK FOOTER //
// polls.create.vue?8e804c7a